export default __webpack_public_path__ + "static/media/img_4.e1b595a7.jpg";